import { defaultFill } from '../../utils/constants';
var muiCreditCard16 = {
    paths: [
        {
            path: 'M14.9991283,0 C15.5518945,0 16,0.455760956 16,1.00247329 L16,10.9975267 C16,11.5511774 15.5468037,12 15.0026177,12 L0.996678026,12 C0.446227952,12 0,11.544239 0,10.9975267 L0,1.00247329 C0,0.448822582 0.444630861,0 1.00087166,0 L14.9991283,0 Z M14,5 L2,5 L2,10 L14,10 L14,5 Z M14,2 L2,2 L2,3 L14,3 L14,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Credit Card',
    width: 16,
    height: 12,
};
var muiCreditCard24 = {
    paths: [
        {
            path: 'M22.9993054,0 C23.5519738,0 24,0.454708934 24,0.999960201 L24,16.0000398 C24,16.5523026 23.5525308,17 22.9993054,17 L1.00069463,17 C0.448026248,17 0,16.5452911 0,16.0000398 L0,0.999960201 C0,0.447697432 0.44746922,0 1.00069463,0 L22.9993054,0 Z M22,7 L2,7 L2,15 L22,15 L22,7 Z M8,11 L8,13 L4,13 L4,11 L8,11 Z M16,11 L16,13 L10,13 L10,11 L16,11 Z M22,2 L2,2 L2,4 L22,4 L22,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Credit Card',
    width: 24,
    height: 17,
};
var muiCreditCard = {
    base: muiCreditCard16,
    smIcon: muiCreditCard16,
    lgIcon: muiCreditCard24,
};
export { muiCreditCard };
//# sourceMappingURL=creditCard.js.map